module.exports = __webpack_public_path__ + "static/img/3_2_1_1.f81e13a4.jpg";